<script setup lang="ts">
import { Collapse } from 'vue-collapsed';
import type { CatalogInApp } from '~/interfaces/app';

const props = defineProps({
  items: {
    type: Array as () => CatalogInApp[],
    required: true,
  },
});
const showMore = ref<boolean>(false);
const firstItems = computed(() => {
  return props.items.slice(0, 3);
});
const moreItems = computed(() => {
  return props.items.slice(3);
});

function setShowMore() {
  showMore.value = !showMore.value;
}
</script>
<template>
  <div class="desk-last-menu">
    <nuxt-link
      v-for="(item, index) in firstItems"
      :key="index"
      itemprop="url"
      class="last-item"
      :to="'/' + item.url + '/'"
    >
      {{ item.title }}
    </nuxt-link>
    <Collapse :when="showMore" class="v-collapse">
      <nuxt-link
        v-for="(item, index) in moreItems"
        :key="index"
        class="last-item"
        :to="'/' + item.url + '/'"
      >
        {{ item.title }}
      </nuxt-link>
    </Collapse>
    <div :class="{ open: !showMore }" class="more" @click.prevent="setShowMore">
      <span v-if="moreItems.length" class="span">
        {{ !showMore ? 'Ещё' : 'Свернуть' }}</span
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.desk-last-menu {
  display: none;
  margin-top: 12px;
  @include fz(14, 20, 400);
  grid-gap: 12px;

  @include xl-block {
    display: grid;
    @include fz(14, 20, 450);
  }

  .more {
    cursor: pointer;
    color: $main-cta;
    margin-bottom: 30px;
    position: relative;
    display: flex;
    align-items: center;

    span {
      position: relative;

      &:after {
        -webkit-mask: url(/static/images/arrow-up.svg) center/contain no-repeat;
        mask: url(/static/images/arrow-up.svg) center/contain no-repeat;
        width: 16px;
        height: 16px;
        background-color: #363ef8;
        transform: rotate(0deg);
        transition: transform 0.3s ease;
        transform-origin: center center;
        content: '';
        position: absolute;
        top: calc(50% - 8px);
        right: -20px;
      }
    }

    &.open {
      .span {
        &:after {
          transform: rotate(180deg);
        }
      }
    }
  }

  .last-item {
    transition: color 0.3s ease-in-out;

    &:hover {
      color: $hover-cta;
    }
  }
}

.v-collapse {
  will-change: height;
  transition: height 300ms cubic-bezier(0.33, 1, 0.68, 1);
  display: grid;
  grid-gap: 12px;
}
</style>
